var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.80625,
    y: 0.30625,
    width: 48.3875,
    height: 48.3875,
    rx: 24.1938,
    fill: "#EB4920"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_695_3547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 16.5H30.9C30.6679 15.3714 30.0538 14.3573 29.1613 13.6287C28.2687 12.9001 27.1522 12.5015 26 12.5L24 12.5C22.8478 12.5015 21.7313 12.9001 20.8387 13.6287C19.9462 14.3573 19.3321 15.3714 19.1 16.5H16C15.7348 16.5 15.4804 16.6054 15.2929 16.7929C15.1054 16.9804 15 17.2348 15 17.5C15 17.7652 15.1054 18.0196 15.2929 18.2071C15.4804 18.3946 15.7348 18.5 16 18.5H17V31.5C17.0016 32.8256 17.5289 34.0964 18.4662 35.0338C19.4036 35.9711 20.6744 36.4984 22 36.5H28C29.3256 36.4984 30.5964 35.9711 31.5338 35.0338C32.4711 34.0964 32.9984 32.8256 33 31.5V18.5H34C34.2652 18.5 34.5196 18.3946 34.7071 18.2071C34.8946 18.0196 35 17.7652 35 17.5C35 17.2348 34.8946 16.9804 34.7071 16.7929C34.5196 16.6054 34.2652 16.5 34 16.5ZM24 14.5H26C26.6203 14.5008 27.2251 14.6934 27.7316 15.0514C28.2381 15.4095 28.6214 15.9155 28.829 16.5H21.171C21.3786 15.9155 21.7619 15.4095 22.2684 15.0514C22.7749 14.6934 23.3797 14.5008 24 14.5ZM31 31.5C31 32.2956 30.6839 33.0587 30.1213 33.6213C29.5587 34.1839 28.7956 34.5 28 34.5H22C21.2044 34.5 20.4413 34.1839 19.8787 33.6213C19.3161 33.0587 19 32.2956 19 31.5V18.5H31V31.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 30.4995C23.2652 30.4995 23.5196 30.3941 23.7071 30.2066C23.8946 30.0191 24 29.7647 24 29.4995V23.4995C24 23.2343 23.8946 22.9799 23.7071 22.7924C23.5196 22.6049 23.2652 22.4995 23 22.4995C22.7348 22.4995 22.4804 22.6049 22.2929 22.7924C22.1054 22.9799 22 23.2343 22 23.4995V29.4995C22 29.7647 22.1054 30.0191 22.2929 30.2066C22.4804 30.3941 22.7348 30.4995 23 30.4995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 30.4995C27.2652 30.4995 27.5196 30.3941 27.7071 30.2066C27.8947 30.0191 28 29.7647 28 29.4995V23.4995C28 23.2343 27.8947 22.9799 27.7071 22.7924C27.5196 22.6049 27.2652 22.4995 27 22.4995C26.7348 22.4995 26.4804 22.6049 26.2929 22.7924C26.1054 22.9799 26 23.2343 26 23.4995V29.4995C26 29.7647 26.1054 30.0191 26.2929 30.2066C26.4804 30.3941 26.7348 30.4995 27 30.4995Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.80625,
    y: 0.30625,
    width: 48.3875,
    height: 48.3875,
    rx: 24.1938,
    stroke: "#F49F0A",
    strokeWidth: 0.6125
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_695_3547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 12.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.cfa36918dc8b687f408190f5a26ad34f.svg";
export { ForwardRef as ReactComponent };